<template>
  <sBadge
    color="var(--black-color)"
    content="AI"
    data-qa="badge-ai"
    inner-styles="padding: 2px 6px; height: 14px; font-size: 10px;"
    :offset-x="offsetX"
    :offset-y="offsetY"
    overlap
    text-color="var(--alert-success-icon)"
    :value="visible">
    <slot/>
  </sBadge>
</template>

<script>
export default {
  name: 'BadgeAI',
  props: {
    offsetX: {
      type: Number,
      default: 17
    },
    offsetY: {
      type: Number,
      default: 13
    },
    visible: {
      type: Boolean,
    }
  },
}
</script>